import { IconButton } from '@mui/material';
import { PATHS } from 'constants';
import { useNavigate } from 'react-router-dom';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';

export default function EditProfile() {
  const navigate = useNavigate();

  return (
    <IconButton onClick={() => navigate(PATHS.settings)}>
      <CreateOutlinedIcon />
    </IconButton>
  );
}
